import { View } from "@thi.ng/atom/view";
import { __optsWithID } from "./idgen.js";
import { Stream } from "./stream.js";
/**
 * Unchecked version of {@link fromView}. Paths can be given as string
 * or tuple.

 * @example
 * ```ts
 * const db = defAtom<any>({ a: 1, b: { c: 2 }});
 *
 * // create stream of `c` value changes
 * fromViewUnsafe(
 *   db,
 *   {
 *     path: "b.c",
 *     tx: (x) => x != null ? String(x) : "n/a"
 *   }
 * ).subscribe(trace("view:"))
 * // view: 2
 *
 * // update `c` in state
 * db.swapInUnsafe("b.c", (x: number) => x + 1);
 * // view: 3
 *
 * db.reset({ a: 10 });
 * // view: n/a
 * ```
 *
 * @param atom -
 * @param opts -
 */
export const fromViewUnsafe = (atom, opts) => fromView(atom, opts);
export function fromView(atom, opts) {
    opts = __optsWithID("view", opts);
    return new Stream((stream) => {
        let isActive = true;
        const tx = opts.tx;
        const view = new View(atom, opts.path, tx
            ? (x) => isActive && ((x = tx(x)), stream.next(x), x)
            : (x) => isActive && (stream.next(x), x), false, opts.equiv);
        return () => {
            isActive = false;
            view.release();
        };
    });
}
